import { classes } from "@omnia/shared/react/react";
import { IOmniaCommand, IOmniaCommandGroup } from "../../types";
import { defineDirective } from "../../utils/angular";
import { isArray, isFunction } from "../../utils/utils";

export function createButtonMenu(): ng.IDirective {

    return defineDirective(ButtonMenuCtrl, "shared/components/buttonMenu/buttonMenu.html", {
        groupCommand: "=",
        datacontext: "="
    });

};

/** @internal */
export class ButtonMenuCtrl {

    static $inject = ["$scope"];
    static instanceNumber = 0;

    showPopupMenu: boolean;

    constructor(private $scope: ng.IScope) {
        ButtonMenuCtrl.instanceNumber++;
        this.uniqueId = "buttonMenu" + ButtonMenuCtrl.instanceNumber;
    }

    private uniqueId: string;
    private groupCommand: IOmniaCommandGroup;
    private datacontext: any;

    getIconCssClass(command: IOmniaCommand) {
        const icon = command?.icon
        return icon && (icon.indexOf(" ") >= 0)
            ? icon
            : "icon icon-" + icon
    }

    getButtonCssClass(command?: IOmniaCommand | IOmniaCommand[]): string {

        // Is this a single "new" command?
        const isNew = command && !isArray(command) && command.icon === "addnew";

        // Is this command (or all of the commands) disabled?
        const isDisabled = command ? isArray(command) ? !this.canExecuteSome(command) : !this.canExecute(command) : false;

        return classes(
            "btn btn-floating-action small",
            {
            "flat green": isNew,
            "flat white": !isNew,
            "disabled": isDisabled
        });
    }

    canExecuteSome(command: IOmniaCommand[]) {

        return command.some(x => this.canExecute(x));

    }

    canExecute(command: IOmniaCommand) {

        // There are two possible methods for "can I do this":
        // - isActive
        // - canExecute

        var isActive = command.isActive?.() ?? true;

        var canExecute = command.canExecute && isFunction(command.canExecute) ? command.canExecute.apply(command, [this.datacontext]) : true;

        return Boolean(isActive && canExecute);

    }

    execute(command: any, $event: ng.IAngularEvent) {

        if (!this.canExecute(command)) return;

        this.showPopupMenu = false;

        var handler = command.execute;

        if (isFunction(handler)) {

            handler.apply(command, [this.datacontext]);

            if ($event) {
                $event.stopPropagation();
            }

        }

    }
}
